import { render, staticRenderFns } from "./threeLeft.vue?vue&type=template&id=4955d284&"
import script from "./threeLeft.vue?vue&type=script&lang=js&"
export * from "./threeLeft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports